__turbopack_context__.v({
  "main": "StopIndex-module-scss-module__F3F1xG__main",
});
